import BaseServiceCrud from './BaseServiceCrud';

export default class UserQuizService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'quiz-manage/user-quiz';
    }

    getCriteria(criteria) {
        const status = criteria.status?.enumValue;
        return this.objToQueryString({
            quizId: criteria.quizId,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            email: criteria.email,
            name: criteria.name,
            status: status
        });
    }

}
